<template>
  <span
    :style="style"
    :class="{ 'item-state': true, 'item-state--success': value, 'item-state--error': !value }"
  ></span>
</template>

<script>
  import { green, blue } from '@shared/helpers/css';

  export default {
    props: {
      size: {
        type: [String, Number],
        default: 20
      },

      value: {
        type: [Boolean, Number],
        default: false
      }
    },

    data() {
      return {
        green,
        blue
      };
    },

    computed: {
      style: function() {
        return {
          width: `${this.size}px`,
          height: `${this.size}px`
        };
      }
    }
  };
</script>

<style lang="scss">
  .item-state {
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;

    &--error {
      background-image: url('/img/icons/item-state-error.svg');
    }

    &--success {
      background-image: url('/img/icons/item-state-success.svg');
    }
  }
</style>
